import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-party-cream text-party-ink" data-id="element-88" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-89" data-mp="9tbhd5l0d4mi">
        <p className="font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-party-brown" data-id="element-90" data-mp="etz2xbqgwt9c">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-party-gold bg-white p-3 text-left" data-id="element-91" data-mp="jsaf3t48jfuq">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-party-gold" data-id="element-92" data-mp="nrrkynnkqf0f">
            <ShieldCheckIcon size={20} className="text-party-ink" data-id="element-93" data-mp="xjnvwzardzm2" />
          </span>
          <div data-id="element-94" data-mp="xlrwb79g8ghl">
            <h2 id="garantia" className="font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-95" data-mp="12ja9j9ui1hve">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-[0.78rem] leading-snug text-party-ink/75" data-id="element-96" data-mp="25sggvb5nq1za">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}